export const blockIconsMapsRestaurantMenuNew = (
	<span className='material-symbols-outlined'>restaurant_menu</span>
);
